/**
 * Модель для работы с конфигурациями
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import AdminService from '../services/AdminService';
import JSON5 from 'json5';

interface IState {
  data: any | null;
  configType: string;
  loading: boolean;
}

const initialState: IState = {
  data: null,
  configType: 'ble',
  loading: false
};

export const settingConfig = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: any): IState {
      return { ...state, data: payload };
    },
    setConfigType(state: IState, payload: string): IState {
      return { ...state, configType: payload };
    },
    setLoading(state: IState, payload: boolean): IState {
      return { ...state, loading: payload };
    },
    reset(): IState {
      return { ...initialState };
    }
  },
  effects: () => ({
    async getConfig(configType: string) {
      try {
        this.setLoading(true);
        const response = await AdminService.getConfig(configType);
        // Сохраняем исходную строку JSON5 с комментариями
        this.setData(response.data);
        this.setConfigType(configType);
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        return error;
      }
    },
    async saveConfig(payload: { configType: string; data: any }) {
      try {
        // data уже в формате JSON5 строки с комментариями
        await AdminService.saveConfig(payload.configType, payload.data);
      } catch (error) {
        return error;
      }
    }
  })
});
